export default "__VITE_ASSET__9a2f1544__"